<template>
  <transition
    name="expand"
    @after-enter="afterEnter"
    @enter="enter"
    @leave="leave"
  >
    <slot></slot>
  </transition>
</template>

<script setup lang="ts">
const afterEnter = (element: Element) => {
  if (!(element instanceof HTMLElement)) return

  element.style.height = 'auto'
}

const enter = (element: Element) => {
  if (!(element instanceof HTMLElement)) return

  const { width } = getComputedStyle(element)

  element.style.width = width
  element.style.position = 'absolute'
  element.style.visibility = 'hidden'
  element.style.height = 'auto'

  const { height } = getComputedStyle(element)

  element.style.width = ''
  element.style.position = ''
  element.style.visibility = ''
  element.style.height = '0'

  getComputedStyle(element).height

  requestAnimationFrame(() => {
    element.style.height = height
  })
}

const leave = (element: Element) => {
  if (!(element instanceof HTMLElement)) return

  const { height } = getComputedStyle(element)

  element.style.height = height

  getComputedStyle(element).height

  requestAnimationFrame(() => {
    element.style.height = '0'
  })
}
</script>

<style scoped lang="scss">
@import '../styles/config';

* {
  will-change: height;
  transform: translateZ(0);
  backface-visibility: hidden;
  perspective: 1000px;
}

.expand-enter-active,
.expand-leave-active {
  overflow: hidden;
  @include transition('height, opacity');
}

.expand-enter-from {
  opacity: 0;
}

.expand-enter-to {
  opacity: 1;
}

.expand-leave-from {
  opacity: 1;
}

.expand-leave-to {
  height: 0;
  opacity: 0;
}
</style>
